/**
 * @module Shop/Order-Payment
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { CardAddressModel } from '@experience/shop/order-payment/online-order-payment/credit-card-address/models/credit-card-address.model';
import { PaymentInformation } from '@support/payment/online-payment/models/card-entry-form.model';

export class OrderPaymentModel {
  public paymentAmount: string;

  public cardDetails: PaymentInformation;

  public cardAddressDetails: CardAddressModel;

  public addressid: string;

  /**
   * Stores whether user select same as Shipping
   */
  public sameAsShipping: boolean;

  public enableAutopay: boolean;
  constructor() {
    this.sameAsShipping = false;
  }
}
